export default {
  contextMenu: {
    backgroundColor: 'white',
    border: '1px solid gray'
  },
  contextMenuItem: {
    padding: '3px 6px',
    '&:hover': {
      backgroundColor: '#CCCCCC',
      '& .circle': { color: '#CCCCCC' }
    }
  },
  contextMenuSeparator: {
    backgroundColor: 'gray',
    height: 1,
    margin: 0,
    padding: 0
  },
  contextMenuLabelIcon: {
    fontSize: '1.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/styles/contextMenu.js